/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

export const resourcesLinks = [
    { title: "Careers", url: "https://www.tol.ca/en/connect/careers.aspx" },
    { title: "Maps & GeoSource", url: "https://www.tol.ca/en/connect/data-maps-and-locations.aspx" },
    { title: "Media Inquiries", url: "https://www.tol.ca/en/connect/media-inquiries.aspx" },
    { title: "MyTownship Account", url: "https://www.tol.ca/en/services/mytownship.aspx?_mid_=41469" },
    { title: "Online Services", url: "https://www.tol.ca/en/services/online-services.aspx" },
    { title: "Open Data Portal", url: "https://www.tol.ca/en/connect/open-data.aspx" },
    { title: "Traffic Impacts", url: "https://www.tol.ca/en/services/traffic-impacts.aspx" },
];

export const websiteLinks = [
    { title: "Township of Langley", url: "https://www.tol.ca/en/index.aspx" },
    { title: "salishan Place - Arts, Culture & Heritage Ctr", url: "https://www.tol.ca/en/salishanplace.aspx" },
    { title: "Fire Department", url: "https://www.tol.ca/en/fire.aspx" },
    { title: "Langley Airport (YNJ)", url: "https://www.tol.ca/en/ynj.aspx" },
    { title: "Tourism Langley", url: "https://www.tourism-langley.ca/" },
];
